/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:57]
Permissions to update outside the main branch: [false]
*/

import { DropDown } from '@finbeat/react-toolkit';
import { AxiosInstance } from 'axios';
import { Dictionary } from 'lodash';
import { Outlet, OutletAdd, OutletChange, OutletFilter, OutletTable } from 'models/api/outlet';
import ResTable from 'models/api/table';

const controller = '/outlets';

export const getOutletsList = async (axios: AxiosInstance, params?: OutletFilter) => {
    const response = await axios.get<ResTable<OutletTable>>(controller, { params });
    return response.data;
};

export const getOutletsExcel = async (axios: AxiosInstance, params: OutletFilter) => {
    const { data } = await axios.get<Blob>(controller + '/excel', {
        responseType: 'arraybuffer',
        params: { ...params },
    });
    return data;
};

export const getOutlet = async (axios: AxiosInstance, id: number | string) => {
    const response = await axios.get<Outlet>(controller + `/${id}`);
    return response.data;
};

export const addOutlet = async (axios: AxiosInstance, item: OutletAdd) =>
    await axios.post<Outlet>(controller, item);

export const changeOutlet = async (axios: AxiosInstance, item: OutletChange) =>
    await axios.put<Outlet>(controller, item);

export const deleteOutlet = async (axios: AxiosInstance, id: number | string) =>
    await axios.delete(controller + `/${id}`);

export const getOutletsAll = async (axios: AxiosInstance, tradeOrgId: number | null) => {
    const { data } = await axios.get<DropDown[]>(controller + '/list', {
        params: { tradeOrgId },
    });
    return data;
};

export const getOutletsSettingsTypes = async (axios: AxiosInstance) => {
    const { data } = await axios.get<Dictionary<string>>(controller + '/settingsTypes');
    return data;
};
